import { Typography } from '@material-ui/core';
import React from 'react';

import { useStyle } from './styles';

const Terms = () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>
        <a target='_blank' rel='noopener noreferrer' href='https://www.eduzz.com/pt-br/legal/termos'>
          Termos de uso
        </a>
      </Typography>

      <Typography className={classes.title}>
        <a target='_blank' rel='noopener noreferrer' href='https://www.eduzz.com/politica-de-privacidade'>
          Política de privacidade
        </a>
      </Typography>
    </div>
  );
};

export default Terms;
